import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import useSessionFlagMutation from '@hooks/useSessionFlagMutation';
import ClinicalCheckbox from '@components/Clinicians/Session/Components/ClinicalCheckbox';

const RedFlagPathologyFormItem = () => {
  const { t } = useTranslation('common');

  const {
    appointment: { read_only: readOnly, appointment_completed: isCompleted }
  } = useSessionAppointment();

  const { mutate: handleFlagChange, isPending: flagsSaving } = useSessionFlagMutation({ field: 'red_flag' });

  return (
    <ClinicalCheckbox
      field="red_flag"
      label={t('clinicalRedFlagLabel')}
      disabled={!!readOnly || !!isCompleted || flagsSaving}
      isSaving={flagsSaving}
      onChange={handleFlagChange}
    />
  );
};

export default RedFlagPathologyFormItem;
